import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './layout/layout.module';

import { registerLocaleData, LocationStrategy, PathLocationStrategy } from '@angular/common';
import locale from '@angular/common/locales/es-CL';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ComponentsModule } from './components/components.module';
import { httpInterceptorProviders } from './shared/interceptors';
import { RouterModule } from '@angular/router';
import { PrebootModule } from 'preboot';
import {TransferHttpCacheModule} from '@nguniversal/common';
import { UnidadGuard } from './shared/guard/unidad.guard';
import { SEOResolve } from './services/seo.service';
import { ConfigModule, ConfigService } from './shared/services/config.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(locale, 'es');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    PrebootModule.withConfig({ appRoot: 'app-root' }),
    AppRoutingModule,
    LayoutModule,
    ComponentsModule,
    HttpClientJsonpModule,
    SharedModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    TransferHttpCacheModule
  ],
  providers: [
    httpInterceptorProviders,
    SEOResolve,
    { provide: LOCALE_ID, useValue: 'es' },
    ConfigService,
    ConfigModule.init()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
